// components/ui/Loading.jsx
import React from 'react';
import { Loader2 } from 'lucide-react';

export const Loading = () => (
    <div className="flex items-center justify-center">
      <Loader2 className="h-8 w-8 animate-spin text-blue-500" />
      <span className="ml-2">처리 중...</span>
    </div>
  );